import { FC } from "react";
import "./ProductDescription.scss";
import arrowDown from "../../../../../Assets/Images/arrow-down.png";

interface propsType {
  productDescription: string;
}

const ProductDescription: FC<propsType> = ({ productDescription }) => {
  return (
    <div className="contentConstruction">
      <div className="desc">
        <h3>Description</h3>
        <div>
          <h5>What it is used for in construction</h5>
          <p>{productDescription}</p>
        </div>
      </div>
      <div className="overview">
        <h2>Specifications</h2>

        <dl className="stats">
          <dt className="firstDt">Diameter</dt>
          <dd>nil</dd>

          <dt>Length</dt>
          <dd>nil</dd>

          <dt>Material</dt>
          <dd>nil</dd>

          <dt>Grade</dt>
          <dd>nil</dd>

          <dt>Packaging</dt>
          <dd>nil</dd>
        </dl>

        <a className="seeMore" href="#">
          See more
        </a>
        <img loading="lazy" src={arrowDown} alt="icon" />
      </div>
    </div>
  );
};

export default ProductDescription;
